/** Entrée de navigation déclarée par chaque module (contrat d'intégration entre agents). */
import type { LucideIcon } from 'lucide-react';
import type { Permission } from '@myron/domain';

export interface EntreeNav {
  libelle: string;
  vers: string;
  /** Au moins une de ces permissions (masquage d'UX). */
  permission?: Permission | Permission[];
  icone?: LucideIcon;
  /** Groupe de la barre latérale admin. */
  groupe?: 'Pilotage' | 'Commercial' | 'Catalogue' | 'Logistique' | 'Achats' | 'Finance' | 'Administration';
  /** Correspondance exacte du chemin pour l'état actif. */
  exact?: boolean;
}

export const filtrerNav = (nav: EntreeNav[], peut: (p: Permission) => boolean) =>
  nav.filter((e) => !e.permission || (Array.isArray(e.permission) ? e.permission.some(peut) : peut(e.permission)));
